export default {
  active: 'Activate',
  send: 'We will send code to your phone',
  phone: 'Phone number',
  enterCode: 'Enter Code',
  sendAgain: 'Send Again',
  enterNewPassword: 'Enter new password',
  reEnterNewPassword: 'Re-enter Password',
  activate: 'Activate',
}
